import { Reports } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconReports12Line = createIcon(Reports, 12, "Line");
export const IconReports16Line = createIcon(Reports, 16, "Line");
export const IconReports20Line = createIcon(Reports, 20, "Line");
export const IconReports24Line = createIcon(Reports, 24, "Line");
export const IconReports32Line = createIcon(Reports, 32, "Line");
export const IconReports48Line = createIcon(Reports, 48, "Line");
export const IconReports64Line = createIcon(Reports, 64, "Line");
